import Highway from '@dogstudio/highway';
import { mouseMovefn } from 'utils.js';
import * as utils from 'utils.js';
import gsap from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default class homeRenderer extends Highway.Renderer {
	onEnter() {

        const director__player = new Plyr('#video__director .video__player', {});
        director__player.on('play', event => {
            document.querySelector('#video__director .plyr__video__poster').classList.add('playing');
        });
        director__player.on('pause', event => {
            document.querySelector('#video__director .plyr__video__poster').classList.remove('playing');
        });

		this.DOM = { view: this.wrap.lastElementChild };
		this.DOM.mosaicSection = this.DOM.view.querySelector(".mosaic__section");
		this.DOM.hugeCatchline = this.DOM.mosaicSection.querySelector(".huge-catchline");

		this.parallaxTiles();
	}

	onEnterCompleted() {
		// Init scrollTrigger when DOM's completed
		this.parallaxTitle();
	}

	parallaxTitle() {
		// Target DOM elements
		this.parallaxTitleMovementTl = gsap.timeline({
			scrollTrigger: {
				trigger: this.DOM.mosaicSection,
				start: "top 85%",
				end: "bottom top",
				toggleActions: "play pause resume reset",
				scrub: true,
				markers: false
			}
		});

		this.parallaxTitleMovementTl.to(this.DOM.hugeCatchline, { xPercent: -84, ease: "none" });

		// Init animation
		this.parallaxTitleMovementTl.scrollTrigger.refresh();
	}

	parallaxTiles() {
		this.DOM.view.querySelector('.mosaique__container').addEventListener('mousemove', mouseMovefn);

		this.DOM.view.addEventListener('mouseleave', (e) => {
			TweenMax.to(e.currentTarget.querySelectorAll('[data-mouse-parallax]'), 1.2, { x: 0, y: 0, ease: Power3.easeOut });
		});
	}

	onLeaveCompleted() {
		// Kill the timeline
		this.parallaxTitleMovementTl.scrollTrigger.kill();
	}
}
